import { LocalizedString } from '../../utils/localizer';

export const form: LocalizedString = {
  errorTitle: {
    nb: 'Beklager, noe gikk galt',
    nn: 'Beklager, ein feil oppstod',
    en: 'Sorry, something went wrong',
  },
  errorBody: {
    nb: 'Vennligst prøv på nytt. Om problemet vedvarer, beskriv hva som feiler og meld fra til <a href="mailto:kundesupport@innovasjonnorge.no">kundesupport@innovasjonnorge.no</a>',
    nn: 'Ver venleg og prøv på nytt. Om problemet held fram, beskriv kva som feiler og meld frå til <a href="mailto:kundesupport@innovasjonnorge.no">kundesupport@innovasjonnorge.no</a>',
    en: 'Please try again. If the problem still occurs, describe the issue and report to <a href="mailto:kundesupport@innovasjonnorge.no">kundesupport@innovasjonnorge.no</a>',
  },
  errorBodyNoRole: {
    nb: 'Bare personer som har en offisiell rolle, registrert i Brønnøysundregistrene, kan sende inn søknaden på vegne av bedriften. For mer informasjon om vår rollestyring, se vår <a href="https://www.innovasjonnorge.no/no/logg-inn-subsite/kan-vi-hjelpe-deg/" target="_blank" rel="noopener noreferrer">FAQ for rollestyring</a>.',
    nn: 'Berre personar med ein offisiell rolle, registrert i Brønnøysundregistrene, kan senda inn søknaden på vegne av bedriften. For meir informasjon om vår rollestyring, sjå vår <a href="https://www.innovasjonnorge.no/no/logg-inn-subsite/kan-vi-hjelpe-deg/" target="_blank" rel="noopener noreferrer">FAQ for rollestyring</a>.',
    en: 'Only persons with an official role, registered in Brønnøysundregistrene, can send an application on behalf of the company. For more information about our role management, see our <a href="https://www.innovasjonnorge.no/no/logg-inn-subsite/kan-vi-hjelpe-deg/" target="_blank" rel="noopener noreferrer">FAQ for role management</a>.',
  },
  errorCloseLabel: {
    nb: 'Tilbake',
    nn: 'Tilbake',
    en: 'Back',
  },
  pageValidationErrorTitle: {
    nb: 'Skjemaet kan ikke sendes inn.',
    nn: 'Skjemaet kan ikkje sendast inn.',
    en: 'The form cannot be submitted.',
  },
  formPageValidationSummaryTitle: {
    nb: 'Skjemaet kan ikke sendes inn på grunn av:',
    nn: 'Skjemaet kan ikkje sendast inn på grunn av:',
    en: 'The form cannot be submitted due to:',
  },
  noConfirmationChosenMessage: {
    nb: 'Vennligst bekreft før innsending.',
    nn: 'Ver venleg og stadfest før innsending.',
    en: 'Please confirm before submission.',
  },
  jumpToFieldAndCorrect: {
    en: 'Click to correct field for:',
    nb: 'Klikk for å rette felt for:',
    nn: 'Klikk for å rette felt for:',
  },
  accessibilityNavBarLabel: {
    en: 'Page {p} of {n}.',
    nb: 'Side {p} av {n}.',
    nn: 'Side {p} av {n}.',
  },
  accessibilityNavBarErrorOnPageLabel: {
    en: 'This page is not filled in correctly.',
    nb: 'Denne siden er ikke utfylt riktig.',
    nn: 'Denne siden er ikke utfylt riktig.',
  },
  fileUploadFailedLabel: {
    en: 'Sorry, something went wrong',
    nb: 'Beklager, noe gikk galt',
    nn: 'Beklager, noe gikk galt',
  },
  fileDownloadFailedlabel: {
    en: 'The form must be valid before download of document',
    nb: 'Skjema må være validert før du kan laste ned dokument',
    nn: 'Skjema må være validert før du kan laste ned dokument',
  },
  fileUploadInfected: {
    en: 'The file seems to be infected. You may contact support if you have any questions.',
    nb: 'Filen ser ut til å være infisert. Du kan ta kontakt med kundestøtte dersom du har spørsmål.',
    nn: 'Fila ser ut til å vere infisert. Du kan ta kontakt med kundestøtte dersom du har spørsmål.',
  },
  fileUploadInvalidFileName: {
    en: 'The file appears to have an invalid name. You may contact support if you have any questions.',
    nb: 'Navnet på filen du laster opp er ugyldig. Du kan ta kontakt med kundestøtte dersom du har spørsmål.',
    nn: 'Namnet på fila du lastar opp er ugyldig. Du kan ta kontakt med kundestøtte dersom du har spørsmål.',
  },
  errorGeneratingSigningDocument: {
    en: 'Could not create signing document',
    nb: 'Kunne ikke opprette signeringsdukument',
    nn: 'Kunne ikkje oppretta signeringsdukument',
  },
  projectAccountingNotificationTitle: {
    en: 'Please check that everything is correct',
    nb: 'Sjekk at alt stemmer',
    nn: 'Sjekk at alt stemmer',
  },
  projectAccountingNotificationText: {
    en: `Verify that all information is correct. Once you complete the project accounts, you will no longer be able to edit them.

    Errors or missing information in the accounts will result in longer processing time and delayed payment.`,
    nb: `Kontroller at all informasjon er korrekt. Når du fullfører prosjektregnskapet, kan du ikke lenger redigere det.

    Feil eller mangler i regnskapet vil føre til lengre behandlingstid og forsinket utbetaling.`,
    nn: `Kontroller at all informasjon er korrekt. Når du fullfører prosjektrekneskapen, kan du ikkje lenger gjere endringar.

    Feil eller manglar i rekneskapen vil føre til lengre handsamingstid og forseinka utbetaling. `,
  },
};
